import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../../components/ui/card';
import Logo from '../../assets/images/stratagenIcon.png';
import { useEffect, useRef, useCallback } from 'react';
import Auth0Lock from 'auth0-lock';
import './login.css';
import { ThemeToggle } from '../../components/theme-toggle';

const Login = () => {
  const navigate = useNavigate();
  const lockRef = useRef<any>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const { AUTH0_DOMAIN, AUTH0_CLIENT_ID } = (window as any).data.auth;

  const initializeLock = useCallback(() => {
    if (!containerRef.current || lockRef.current) return;

    lockRef.current = new Auth0Lock(AUTH0_CLIENT_ID, AUTH0_DOMAIN, {
      container: containerRef.current.id,
      closable: false,
      auth: {
        redirectUrl: window.location.href,
        responseType: 'token id_token',
        params: {
          scope: 'openid profile email',
        },
      },
      languageDictionary: {
        title: 'welcome',
        forgotPasswordAction: 'Reset or Change your Password',
      },
      allowSignUp: true,
      initialScreen: 'signUp',
      rememberLastLogin: false,
    });

    const handleAuthentication = async (authResult: any) => {
      try {
        const getUserInfo = () => {
          return new Promise((resolve, reject) => {
            lockRef.current?.getUserInfo(
              authResult.accessToken,
              (error: any, profile: any) => {
                if (error) reject(error);
                else resolve(profile);
              }
            );
          });
        };
        const result: any = await getUserInfo();
        localStorage.setItem('userEmail', result.email);
        localStorage.setItem('accessToken', authResult.accessToken);
        navigate('/dicom');
      } catch (error) {
        console.error('Authentication error:', error);
      }
    };

    lockRef.current.on('authenticated', handleAuthentication);
    lockRef.current.show();
  }, [navigate, AUTH0_CLIENT_ID, AUTH0_DOMAIN]);

  useEffect(() => {
    initializeLock();
  }, [initializeLock]);

  return (
    <div className="relative w-full flex justify-center items-center h-screen bg-background">
      <ThemeToggle className="absolute top-4 right-4" />
      <div className="text-4xl flex flex-col gap-2 h-full justify-center items-center">
        <div className="flex gap-2">
          <img src={Logo} alt="Logo" className="w-16 h-16 mt-2" />
          <div className="flex flex-col">
            <span className="text-[#201D46] dark:text-foreground">Stratagen</span>
            <span className="text-[#201D46] dark:text-foreground">bio</span>
          </div>
        </div>
        <div className="text-3xl font-medium text-foreground">Exam Upload</div>
      </div>
      <div className="w-[350px] h-[500px]">
        <Card className="w-[350px] border border-border bg-card shadow-xl ml-10 overflow-hidden">
          <CardContent className="p-0 items-center">
            <div
              ref={containerRef}
              id="auth0-login-container"
              className="min-h-[500px]"
            />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Login;
